module.exports = __webpack_public_path__ + "img/storeNum2.c82256db.png";